import StackTraceError from './StackTraceError';

export default class ServerError extends StackTraceError {
  constructor(code = 500, message = 'Server Error', errors = {}) {
    super(message);
    this.code = code;
    this.errors = errors;
  }

  getCode = () => this.code;
}
